import React from 'react';
import './CertificationBanner.scss';
import isoBadge from '../assets/images/iso-badge.png';

const CertificationBanner = () => {
    return (
        <div className="certification-banner">
            <div className="certification-banner__badges">
                <img src={isoBadge} alt="ISO 27001:2013" className="certification-banner__badge" />
            </div>
        </div>
    );
};

export default CertificationBanner;